import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => (direction ?? "row")};
  align-items: center;
`;